import { render, staticRenderFns } from "./SearchFilterItem.vue?vue&type=template&id=11681590&scoped=true"
import script from "./SearchFilterItem.vue?vue&type=script&lang=js"
export * from "./SearchFilterItem.vue?vue&type=script&lang=js"
import style0 from "./SearchFilterItem.vue?vue&type=style&index=0&id=11681590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11681590",
  null
  
)

export default component.exports